/**
 * Super-admin email allowlist.
 *
 * The 2 super-admins listed here are the ONLY users who see the "Team Members"
 * section in /admin/settings (the Admin Invite UI).
 *
 * Keep this file in lockstep with `packages/workers/src/lib/super-admins.ts`.
 * To add a 3rd super-admin: edit BOTH files, redeploy worker + frontend.
 */
export const SUPER_ADMIN_EMAILS: readonly string[] = [
  'flavio+admin@mapmatix.com',
  'rsaab@stagedooraccess.com',
] as const;

export function isSuperAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase().trim());
}
